import React, { useState } from 'react';
import styled from 'styled-components';
import { MediaData } from '~admin/model/media-data';
import { Box } from '~common/components/box.component';

interface Props {
  media: MediaData;
  onMediaSelected?: (media: MediaData) => void;
}

export const MediaListImageItem: React.FunctionComponent<Props> = ({ media, onMediaSelected }) => {
  const [error, setError] = useState<boolean>(undefined);

  if (error) {
    return null;
  }

  return (
    <Container>
      <Image
        src={media?.url}
        alt={media?.description}
        onError={(): void => {
          setError(true);
        }}
        onClick={(): void => {
          onMediaSelected?.(media);
        }}
        loading={'lazy'}
      />
    </Container>
  );
};

const Container = styled(Box)`
  flex: 1 1 170px;
  align-items: center;
  justify-content: center;
  margin: 4px;

  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  object-fit: contain;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media/media-list/media-list-image-item.component.tsx